import * as React from 'react';

const Marker = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={16} height={23} viewBox="0 0 16 23" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="#1F3645"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.1}
            transform="translate(1)"
        >
            <circle cx={7.214} cy={7.906} r={3.594} />
            <path d="M7.214.719a7.187 7.187 0 0 1 7.188 7.187c0 3.265-4.863 11.452-6.589 14.054a.72.72 0 0 1-1.198 0C4.89 19.358.027 11.171.027 7.906A7.187 7.187 0 0 1 7.214.72" />
        </g>
    </svg>
);
export default Marker;
